import React from "react"
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import * as Icons from "react-feather";
import { styles } from "./style";

interface Props extends
	WithStyles<typeof styles> {
	label: string,
	placeholder?: string,
	value?: string,
	errorText?: string | false,
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
	tooltip: string,
	maxWidth?: number,
}

class Component extends React.Component<Props> {
	public render() {
		const { classes = {}, onChange, value, errorText, label, placeholder, tooltip, maxWidth } = this.props;

		const labelContent = (
			<span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<span>{label}</span>
				<Mui.Tooltip title={tooltip} placement="right" arrow>
					<Mui.IconButton
						size="small"
						color="primary"
						style={{ padding: 0, width: 20, height: 20 }}
						onMouseDown={(e) => e.preventDefault()}
					>
						<Icons.Info size={16} />
					</Mui.IconButton>
				</Mui.Tooltip>
			</span>
		);

		return (
			<Mui.Grid container direction="row" spacing={2}>
				<Mui.Grid item xs={12} sm className={maxWidth ? classes.fieldContainer : undefined}>
					<Mui.TextField
										label={labelContent}
										placeholder={placeholder}
										helperText={errorText}
										error={!!errorText}
										FormHelperTextProps={{
											className: classes.errorMessage
										}}
										variant="outlined"
										value={value}
										onChange={onChange}
										InputLabelProps={{
											shrink: true,
											style: { pointerEvents: 'auto' }
										}}
										fullWidth />
				</Mui.Grid>
			</Mui.Grid>
		);
	}
}

export const FullWidthFieldWithTooltip = withStyles(Component, styles)
